/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Card, CardBody, Col, Container, Row, Table,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useHistory, useParams } from 'react-router';

const SingleEnquiry = ({ rtl }) => {
  const { t } = useTranslation('common');
  const [cookies, setCookie] = useCookies(['tranAuthToken']);
  const { id } = useParams();
  const
    {
      data,
      isLoading,
      isFetching,
      isError,
    } = useQuery('singleEnquire', () => axios.get(`https://orca-app-5i5qx.ondigitalocean.app/api/admin/enquiry/single?enquiryId=${id}`, {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }));
  if (data && !isLoading && !isFetching && !isError) {
    console.log('single Enquiry', data.data);
  }

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Enquiry Details </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">Enquiry Details Table</h5>
              </div>
              <Table responsive hover className="table--bordered">

                {/* <tr>
                  <th>ID</th>
                  <th>Advance</th>
                  <th>Against Bill</th>
                  <th>Enquiry By</th>
                  <th>Loading Expanses</th>
                  <th>Loading Time</th>
                  <th>Material</th>
                  <th>PickUp Address Id</th>
                  <th>Remarks</th>
                  <th>Time Stamp</th>
                  <th>To Consignee Id</th>
                  <th>Truck Type</th>
                  <th>Unloading Expense </th>
                  <th>Weight</th>
                </tr> */}
                {isFetching && <tr><td>Loading...</td></tr>}
                {!isLoading && !isError && data && data.data && data.data
                  && (
                    <>
                      <tr>
                        <th>Id</th>
                        <td>{data.data.enquiry.enquiryUquid}</td>
                      </tr>
                      <tr>
                        <th>Advance</th>
                        <td>{data.data.enquiry.advance}</td>
                      </tr>
                      <tr>
                        <th>Against Bill</th>
                        <td>{data.data.enquiry.againstBill}</td>
                      </tr>
                      <tr>
                        <th>Consignor</th>
                        <td>{data.data.enquiry.consignor}</td>
                      </tr>
                      <tr>
                        <th>Enquiry By</th>
                        <td>{data.data.enquiry.enquiryBy._id}</td>
                      </tr>
                      <tr>
                        <th>Loading Expanses</th>
                        <td>{data.data.enquiry.loadingExpense}</td>
                      </tr>
                      <tr>
                        <th>Loading Time</th>
                        <td>
                          {new Date(data.data.enquiry.loadingTime).toLocaleDateString()}
                        </td>
                      </tr>
                      <tr>
                        <th>Material</th>
                        <td>{data.data.enquiry.material}</td>
                      </tr>
                      <tr>
                        <th>PickUp Address Id</th>
                        <td>{data.data.enquiry.pickupAddresssId}</td>
                      </tr>
                      <tr>
                        <th>Remarks</th>
                        <td>{data.data.enquiry.remarks}</td>
                        <td>
                          {new Date(data.data.enquiry.remarks).toLocaleDateString()}
                        </td>
                      </tr>
                      <tr>
                        <th>Timestamp</th>
                        <td> {new Date(data.data.enquiry.createdAt).toLocaleDateString()}</td>
                      </tr>
                      <tr> 
                        <th>To ConsigneeId</th>
                        <td>
                          {data.data.enquiry.toConsigneeId}
                        </td>
                      </tr>
                      <tr>
                        <th>Truck Type</th>
                        <td>{data.data.enquiry.truckType}</td>
                      </tr>
                      <tr>
                        <th>Unloading Expense</th>
                        <td>{data.data.enquiry.unloadingExpense}</td>
                      </tr>
                      <tr>
                        <th>Weight</th>
                        <td>{data.data.enquiry.weight}</td>
                      </tr>
                    </>
                  )
                  // <tr key={item.id}>
                  //   {/* <td>{data.data + 1}</td> */}
                  //   <td>{item.advance}</td>
                  //   <td>{item.againstBill}</td>
                  //   <td>{item.enquiryBy}</td>
                  //   <td>{item.loadingExpense}</td>
                  //   <td>{new Date(item.loadingTime).toLocaleDateString()}</td>
                  //   <td>{item.material}</td>
                  //   <td>{item.pickupAddresssId}</td>
                  //   <td>{item.remarks}</td>
                  //   <td>{new Date(item.timestamp).toLocaleDateString()}</td>
                  //   <td>{item.toConsigneeId}</td>
                  //   <td>{item.truckType}</td>
                  //   <td>{item.unloadingExpense}</td>
                  //   <td>{item.weight}</td>
                  //   <td><Badge color="success" onClick={() => history.push(`/all_enquiries/enquiry/${item._id}`)}>more...</Badge></td>
                  // </tr>
                }

              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Card>
        <CardBody>
          <Row>
            <Col md={12} lg={12}>
              <div className="card__title">
                <h5 className="bold-text">Shipment Details Table</h5>
              </div>
              <div className="card__title">
                <h5 className="bold-text">From</h5>
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>Address</th>
                    <th>District</th>
                    <th>Location</th>
                    <th>State</th>
                  </tr>

                </thead>
                <tbody>

                  {isFetching && <tr><td>Loading...</td></tr>}
                  {!isLoading && !isError && data && data.data && data.data.from
                    && (

                      <tr>
                        <td>{data.data.from.address}</td>
                        <td>{data.data.from.district}</td>
                        <td>{data.data.from.location}</td>
                        <td>{data.data.from.state}</td>
                      </tr>
                    )

                  }
                </tbody>

              </Table>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12}>

              <div className="card__title singleEnquiry_to_headings ">
                <h5 className="bold-text">To</h5>
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>Consignee Email</th>
                    <th>Consignee Name</th>
                    <th>Address</th>
                    <th>District</th>
                    <th>Location</th>
                    <th>State</th>
                  </tr>

                </thead>
                <tbody>

                  {isFetching && <tr><td>Loading...</td></tr>}
                  {!isLoading && !isError && data && data.data && data.data.to
                    && (

                      <tr>
                        <td>{data.data.to.email}</td>
                        <td>{data.data.to.userName}</td>
                        <td>{data.data.to.address}</td>
                        <td>{data.data.to.district}</td>
                        <td>{data.data.to.location}</td>
                        <td>{data.data.to.state}</td>
                      </tr>
                    )

                  }
                </tbody>

              </Table>
            </Col>
          </Row>
        </CardBody>
      </Card>


    </Container>
  );
};

SingleEnquiry.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(SingleEnquiry);
